import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

const benefitCardSliders = document.querySelectorAll(
	'.block-benefit-card-slider-desktop'
);

if (benefitCardSliders.length) {
	const initSwiper = (block) => {
		const slider = block.querySelector('.swiper');

		const settings = {
			grabCursor: true,
			spaceBetween: 20,
			slidesPerView: 1,
			modules: [A11y, Navigation],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				nextEl: block.querySelector('.swiper-button-next'),
				prevEl: block.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				992: {
					slidesPerView: 3,
				},
			},
		};

		new Swiper(slider, settings);
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				observer.unobserve(entry.target);
				initSwiper(entry.target);
			});
		},
		{ rootMargin: '200px 0px' }
	);

	benefitCardSliders.forEach((block) => observer.observe(block));
}
